<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>
        <div v-if="!visibleAuditDax">

            <b-row style="margin: 0 0 15px 0">
                <custom-multiselect v-model="userSelected" 
                                    :options="options" 
                                    :internal-search="false"
                                    label="FullName"
                                    placeholder="Выберите пользователя"
                                    @search-change="changeUsers"
                                    @select="getUserAudits" />
                <a href="" name="audit"></a>
            </b-row>

            <b-row class="m-0">
                <b-col md="5" lg="3" sm="12" class="p-0">
                    <div v-if="loadUserAudits.Loading" class="container-tab-spinner">
                        <spinner />
                    </div>
                    <div v-else-if="!userAudits.length && userSelected && !loadUserAudits.Loading">
                        <div class="mb-15 center">
                            <font-awesome-icon icon="clipboard-list" size="4x" color="#9d9d9d"/>
                        </div>
                        <div class="center stub-ladel">
                            У выбранного пользователя нет аудитов
                        </div>
                    </div>
                    <b-list-group v-else>
                        <b-list-group-item button 
                                           v-for="(item, index) in userAudits"
                                           :key="index"
                                           @click="getAudit(item)"
                                           class="wrap-name-property">

                            <div class="mb-5px"> <span> Имя: </span> {{ item.Name }} </div>
                            <div class="mb-5px"> <span> Создан: </span> {{ getDateToDisplay(item.CreatedDate) }} </div>
                            <div class="mb-5px"> <span> Активность: </span> {{ item.TemplateName }} </div>

                            <div class="mb-5px"> 
                                <span> Статус: </span> 
                                <span :style="`color: ${statusColor(item.Status)}; margin-left: 5px`">
                                    {{ statusText(item.Status) }}
                                </span> 
                            </div>

                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col>
                    <div v-if="loadAudit.Loading" class="container-tab-spinner">
                        <spinner />
                    </div>
                    <div v-else-if="audit">                        
                        <b-row class="m-0">
                            <b-col class="p-0 audit-block-row">
                                <div id="audit-name"> 
                                  <h3 class="m-0"> 
                                  {{ getDateToDisplay(audit.Name, audit.LocalTimeZone, true) }} 
                                  {{ audit.LocalTimeZone != '00:00:00' ?  `(GMT+${Number(audit.LocalTimeZone.split(':')[0])})` : '' }} 
                                  </h3> 
                                  <span :style="`color: ${statusColor(audit.Status)}; margin-left: 10px`"> {{ statusText(audit.Status) }} </span>  
                                </div>
                                <b-row class="mb-5px"> <span> Тип: </span> {{ getAuditType(audit.Type) }}  </b-row>
                                <b-row class="mb-5px"> <span> Создан:</span>
                                  {{ getDateToDisplay(audit.CreatedDate, audit.LocalTimeZone)  }}  
                                  {{ audit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(audit.LocalTimeZone.split(':')[0])})` : '' }} 
                                </b-row>
                                <b-row class="mb-5px"> <span> Отправлен:</span>{{ sendText() }}  </b-row>
                                <b-row class="mb-5px"> <span> Активность:</span>{{ audit.TemplateName }} </b-row>
                                <b-row class="mb-5px"> <span> Комментарий:</span>{{ audit.Comment ? audit.Comment : 'Отсутствует' }} </b-row>
                                <b-row class="mb-5px"> <span> Локация создания:</span>{{ locationText(audit.CreationLocation) }} </b-row>
                                <b-row class="mb-5px"> <span> Локация завершения:</span>{{ locationText(audit.CompletionLocation) }} </b-row>
                                <b-row class="mb-5px"> <span> Версия приложения:</span>{{ audit.AppVersion ? audit.AppVersion : "Нет информации" }} </b-row>
                                <b-row class="mb-5px"> <a :href="openAuditLink" class="admin-link" target="_blank"> Открыть аудит </a> </b-row>
                                <b-row class="mb-5px" v-show="audit.Status === 2 || audit.Status === 3 || audit.Status === 4"> <a href="#" class="admin-link" @click="openClosed"> Перевести аудит в работу </a> </b-row>
                                <b-row class="mb-5px" v-if="audit.Status == 3"> <a class="admin-link" v-bind:href="linkForGetAuditResults" target="_blank"> Ссылка на получение результата аудита </a> </b-row> 
                                <b-row class="mb-5px" v-if="audit.Status == 3"> <a class="admin-link" href="#" @click="resendAudit(audit)">Переотправить аудит </a> </b-row> 
                                <b-row class="mb-5px" v-if="audit.Status == 3"> <a class="admin-link" href="#" @click="getAuditDax()"> Посмотреть результаты аудита </a> </b-row>
                            </b-col>
                        </b-row>

                        <b-row class="m-0">
                            <b-col class="p-0" sm="12" md="12" lg="6">
                                <b-list-group>
                                    <b-list-group-item v-for="(item, index) in audit.FormList" :key="index" class="wrap-name-property">

                                        <div class="mb-5px"> <span>ТТ: </span>{{ item.Name }} </div>
                                        <div class="mb-5px"> <span>Создан: </span>
                                          {{ getDateToDisplay(item.CreationDate && item.CreationDate != defaultStringDateConst ? item.CreationDate : (item.Check ? item.Check.CreationDate : null), audit.LocalTimeZone) }} 
                                          {{ audit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(audit.LocalTimeZone.split(':')[0])})` : '' }} 
                                        </div>
                                        <div class="mb-5px"> <span>Завершен: </span>
                                          {{ item.Status != 1 ? getDateToDisplay(item.CompletionDate && item.CompletionDate != defaultStringDateConst ? item.CompletionDate : (item.Check ? item.Check.CompletionDate : null), audit.LocalTimeZone) : '-' }} 
                                          {{ item.Status != 1 && audit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(audit.LocalTimeZone.split(':')[0])})` : '' }}
                                        </div>
                                        <div class="mb-5px"> <span>Локация создания: </span>{{ locationText(item.CreationLocation ? item.CreationLocation : (item.Check ? item.Check.CreationLocation : null)) }} </div>
                                        <div class="mb-5px"> <span>Локация завершения: </span>{{ locationText(item.CompletionLocation ? item.CompletionLocation : (item.Check ? item.Check.CompletionLocation : null)) }} </div>
                                        <div class="mb-5px"> <span>Время получения ТТ с back: </span>
                                          {{ item.TradePoint && item.TradePoint.SyncDate ? getDateToDisplay(item.TradePoint.SyncDate, audit.LocalTimeZone, false, true) : "Нет информации" }} 
                                          {{ item.TradePoint && item.TradePoint.SyncDate && audit.LocalTimeZone != '00:00:00' ? "(GMT+" + Number(audit.LocalTimeZone.split(':')[0])+ ")" : ''}}
                                        </div>
                                        <div class="mb-5px">
                                            <span>Статус: </span>
                                            <span :style="'color: ' + statusColor(item.Status)">
                                                {{ statusText(item.Status) }}
                                            </span> 
                                        </div>    

                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>
                    </div>
                    
                </b-col>

            </b-row>

            <a href="#audit">
                <div class="scroll-up">                
                    <font-awesome-icon icon="caret-up" size="2x" />                
                </div>
            </a>
        </div>
        
        <div v-else>
            <audit-result-viewer v-model="visibleAuditDax" :audit="auditDAX" :localTimeZone="localTimeZone" :isWeb="audit.AppVersion"/>
        </div>

    </div>
</template>

<script>
import '@/assets/styles/admin/audits/audits.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import AuditResultViewer from '@/components/admin/audits/AuditResultViewer'
import allRoutes from '../../../routes/all.routes'

import Consts from '@/store/models/consts/sharedConsts'

export default {
    data: function() {
        let load = new Loading();
        let loadUserAudits = new Loading();
        let loadAudit = new Loading();

        this.getUsers(load);
        return {
            users: null,
            options: null,

            visibleAuditDax: false,

            load: load,
            loadUserAudits: loadUserAudits,
            loadAudit: loadAudit,

            userSelected: null,
            userAudits: [],

            audit: null,
            auditDAX: null,

            localTimeZone: null,

            linkForGetAuditResults: '',

            defaultStringDateConst: Consts.defaultStringDate
        }
    },
    computed: {
        openAuditLink: function() {
            return `${allRoutes.Client.Audit.Index}?id=${this.audit.Id}`;
        }
    },
    methods: {
        resendAudit: function(audit) {
            this.loadAudit.Calculate(true);

            apiService.Admin.Audits.ResendAudit(audit.Id)
                .then(response => {
                    this.loadAudit.Calculate(false);
                })
                .catch(exception => {
                    alert("Аудит не переотправлен");
                    this.loadAudit.Calculate(false);
                });

        },
        getUsers: function(load) {
            load.Calculate(true);

            apiService.Admin.Audits.GetUsers()
                .then(response => {
                    this.users = response.data;
                    this.options = this.users;
                    load.Calculate(false);
                })
                .catch(exception => {
                    load.Calculate(false);
                });
        },

        getUserAudits: function(user) {

            this.userAudits = [];
            this.audit = null;
            this.auditDAX = null;

            if(!user) 
                return;                      

            this.loadUserAudits.Calculate(true);

            apiService.Admin.Audits.GetUserAuditInfos(user.Id)
                .then(response => {
                    this.userAudits = response.data;
                    this.loadUserAudits.Calculate(false);
                })
                .catch(exception => {
                    console.log(exception);
                    this.loadUserAudits.Calculate(false);
                });
        },

        openClosed: function() {
            this.loadAudit.Calculate(true);
            apiService.Admin.Audits.OpenClosed(this.userSelected.Id, this.audit.Id)
                .then(response => {
                    this.audit.Status = 1;
                    this.loadAudit.Calculate(false); 
                }).catch(exception => {
                    console.log(exception);  
                    this.loadAudit.Calculate(false);                  
                })
        },

        getAudit: function(audit) {
            this.loadAudit.Calculate(true);
            apiService.Admin.Audits.GetUserAuditData(this.userSelected.Id, audit.Id)
                .then(response => {
                    this.audit = response.data;                                 
                    this.loadAudit.Calculate(false);
                })
                .catch(exception => {
                    console.log(exception);  
                    this.loadAudit.Calculate(false);                  
                });
                
            if(audit.Status == 3){
                this.linkAuditDax(audit);
            }
        },

        linkAuditDax: function(audit) {

            apiService.Admin.Audits.GetAuditLink(audit.SendDate, audit.Id)
            .then(response => {
                this.linkForGetAuditResults = response.data;
            }).catch(exception => {
                    alert("Ошибка получения ссылки на скачивание результатов аудита.");
            });
        },

        statusColor: function(status) {
            switch (status) {
                case 0:
                    return "black";
                case 1:
                    return "#f39f18";
                case 2:
                    return "#00af00";
                case 3:
                    return "#1faee9";
                case 4:
                    return "red";
                default:
                    return "black";
            }
        },
        statusText: function(status) {
            switch (status) {
                case 0:
                    return "INVALID";
                case 1:
                    return "В работе";
                case 2:
                    return "Завершен";
                case 3:
                    return "Отправлен";
                case 4:
                    return "Удален";
                default:
                    return "ERROR";
            }
        },

        sendText: function() {
            switch (this.audit.Status) {
                case 1:
                case 4:
                    return "Не отправлен";
                case 2:
                    return "XXXXXXXXX";
                case 3:
                     return this.audit.LocalTimeZone != '00:00:00' ? `${this.getDateToDisplay(this.audit.SendDate, this.audit.LocalTimeZone, false, true)} 
                          (GMT+${Number(this.audit.LocalTimeZone.split(':')[0])})
                        ` : this.getDateToDisplay(this.audit.SendDate)
                default:
                    return "ERROR";
            }
        },

        getAuditType: function(type) {
            switch (type) {
                case 0:
                    return "INVALID";
                case 1:
                    return "Полевая активность";
                case 2:
                    return "Горячая линия";
                case 3:
                    return "Я - инспектор";
            }
        },

        locationText: function(location) {
            // var locAllowed = location.IsLocationAllowed ? "[Ok]" : "[Доступ не дан]";
            // if (location.Coordinates === null)
            //     return locAllowed + " Координат нет";

            // return locAllowed + " " + location.Coordinates.Latitude + " | " + location.Coordinates.Longitude;
            if(!location)
                return 'Неизвестно';

            return location.Latitude + " | " + location.Longitude;
        },

        changeUsers: function(value) {
            this.audit = null;
            this.auditDAX = null;

            if(value)
                this.options = this.users.filter(e => e.Dax.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || 
                                                      e.Id.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || 
                                                      e.FullName.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
                                                      e.Email.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            else    
                this.options = this.users;
        },

      getDateToDisplay: function (value, localTimeZone, parseDateToRu, offBrowserLocalTimeZone) {
        let dateToDisplay = new Date(value);
        if (parseDateToRu && this.audit.AppVersion != 'Web') {
          dateToDisplay = dateToDisplay.toLocaleString()
        }       
        
        //Проверка корректного преобразования значения в дату
        if (Number.isNaN(Number(dateToDisplay))) {
          return value
        } 
        this.localTimeZone = localTimeZone != undefined ? localTimeZone : this.localTimeZone;
        //Получение даты с учетом след. факторов: откуда аудит, проверка переменную "localTimeZone",
        //и обработка с учетом GMT+3 на сервере
        localTimeZone != undefined && this.localTimeZone != '00:00:00' && (this.audit.AppVersion == 'Web' ? true : offBrowserLocalTimeZone) ?
          3 > Number(localTimeZone.split(':')[0])
            ? dateToDisplay.setHours(dateToDisplay.getHours() - (3 - Number(localTimeZone.split(':')[0])))
            : dateToDisplay.setHours(dateToDisplay.getHours() + (Number(localTimeZone.split(':')[0]) - 3))
          : dateToDisplay;
        dateToDisplay = `${this.getDateString(dateToDisplay)} ${this.getTimeString(dateToDisplay)}`;
        return dateToDisplay;    
      },

        getDateString(value) {
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },

        getTimeString(value) {
            const hours = `${value.getHours()}`.length == 1 
                            ? `0${value.getHours()}`
                            : value.getHours();

            const minutes = `${value.getMinutes()}`.length == 1 
                            ? `0${value.getMinutes()}`
                            : value.getMinutes();

            const seconds = `${value.getSeconds()}`.length == 1 
                            ? `0${value.getSeconds()}`
                            : value.getSeconds();

            return `${hours}:${minutes}:${seconds}`;
        },

        getAuditDax: function() {
            this.load.Calculate(true);

            apiService.Admin.Audits.GetAuditDax(this.audit.Id)
                .then(response => {
                    this.auditDAX = response.data;
                    this.visibleAuditDax = true;
                    this.load.Calculate(false);
                })
                .catch(exception => {
                    console.log(exception);  
                    this.load.Calculate(false);                  
                });
        }

    },
    components: {
        Spinner,
        CustomMultiselect,
        AuditResultViewer
    }
    
}
</script>